// extracted by mini-css-extract-plugin
export var logo = "_9p-2";
export var logoWrapper = "_9p-1";
export var strip = "_9p-0";